$(document).ready(function () {
    $('.readmore_btn').click(function (event) {
        event.preventDefault();
        var descriptionFull = $(this).parents('.product-description-short').next();
        // descriptionFull.show();
        var descriptionShort = $(this).parents('.product-description-short');
        // descriptionShort.hide();
        descriptionFull.addClass('visible');
        descriptionShort.addClass('invisible');
    });
    $('.readless_btn').click(function (event) {
        event.preventDefault();
        var descriptionFull = $(this).parents('.product-description-full');
        // descriptionFull.hide();
        var descriptionShort = $(this).parents('.product-description-full').prev();
        // descriptionShort.show();    
        descriptionFull.removeClass('visible');  
        descriptionShort.removeClass('invisible');
    });
    $(".image_toggle").click(function () {

        $(this).parents('.video_container').find("#videoModal").css("display", "flex");
        var videoElement = $(this).parents('.video_container').find(".modal-content video-media")[0];
        if(videoElement){
            videoElement.play();
        }       
    });
    

    $(".close_toggle").click(function () {

        var videoElement = $(this).parents('.video_container').find(".modal-content video-media")[0];
        if(videoElement){
            videoElement.pause();
         }
        $(this).parents('.video_container').find("#videoModal").css("display", "none");
    });
    $(".shopify-section--video-image .loadmore").click(function () {
        $('.shopify-section--video-image .video_container').removeClass('container_hide');
        $(this).hide();
    });
    
});